let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1EIUf")).then(() => parcelRequire('9U2Pr'));